// Cache utils

interface SetOptions {
    // 到期时间
    expires: number;
}

export async function get<T>(key: string): Promise<T | undefined>;
export async function get<T>(key: string, defaultValue: T): Promise<T>;
export async function get<T>(key: string, defaultValue?: T): Promise<T | undefined> {
    try {
        const value = localStorage.getItem(key);
        if (value === null) {
            return defaultValue;
        }

        const returnValue = JSON.parse(value!);

        // 如果包含 __exp__ 过期字段，需要判断是否已过期
        if (returnValue['__exp__']) {
            // 已过期
            if (Date.now() > returnValue['__exp__']) {
                return defaultValue;
            }

            return returnValue['data'];
        }

        return returnValue;
    } catch (err) {
        return defaultValue;
    }
}

export async function set(key: string, value: any, options?: SetOptions) {
    try {
        let setValue = value;

        if (options && options.expires) {
            setValue = {
                data: value,
                __exp__: options.expires
            };
        }

        localStorage.setItem(key, JSON.stringify(setValue));
    } catch (err) {
        console.error(err);
    }
}
